import React from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
// import Button from '@mui/material/Button'
import Cards from '../components/Cards/Cards'
import Typography from '@mui/material/Typography'
import { useTranslation } from '../hook/Translation';
import Accordions from '../components/Accordions/Accordions'
import CompareSlider from '../components/Slider/CompareSlider'
import HalfSizeBanner from '../components/Banners/HalfSizeBanner'
import TextBtnSection from '../components/Section/TextBtnSection'
import SmallCards from '../components/Cards/SmallCards'
import ContentCard from '../components/Cards/ContentCard'
import BigCard from '../components/Cards/BigCard'

export default function Fractional() {
    const { t } = useTranslation();
    const TextBtnSectionData = {
        type: t('skinTherapies'),
        title: t('fractional_co2_resurfacing.TextBtnSectionDataTitle'),
        description: t('fractional_co2_resurfacing.TextBtnSectionDataDescription'),
        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e FRACTIONAL CO₂ RESURFACING")}`,
        target: '_blank',
        price: t('fractional_co2_resurfacing.pricing'),
        doctorIncluded: true
    };

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            // title: t('time'),
            title: t('time'),
            description: t('fractional_co2_resurfacing.time'),
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            // title: t('discomfort'),
            title: t('discomfort'),
            description: t('fractional_co2_resurfacing.discomfort'),
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            // title: t('downtime'),
            title: t('downtime'),
            description: t('downtime'),
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            // title: t('sessions'),
            title: t('sessions'),
           description: t('fractional_co2_resurfacing.sessions'),
        }
    ];

    const data = [
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 17.png`,
            header: t('face'),
            description: t('fractional_co2_resurfacing.faceDesc'),
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 18.png`,
              header: t('neck'),
            description: t('fractional_co2_resurfacing.neckDesc'),
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 19.png`,
              header: t('deolletage'),
            description: t('fractional_co2_resurfacing.decolletageDesc'),
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/',
        },
    ]

    const accodirons = [
        {
            title: t('what'),
            content: t('fractional_co2_resurfacing.what'),
        },
        {
            title: t('how'),
            content: t('fractional_co2_resurfacing.how'),
        },
        {
            title: t('benefits'),
            content: t('fractional_co2_resurfacing.benefits'),
        },
        // {
        //     title: t('zone'),
        //     content: t('fractional_co2_resurfacing.zone'),
        // },
        {
            title: t('healingTime'),
            content: t('fractional_co2_resurfacing.healingTime'),
        },
        // {
        //     title: t('downtime'),
        //     content: t('fractional_co2_resurfacing.downtime_details'),
        // },
        {
            title: t('when_expected_results'),
            content: t('fractional_co2_resurfacing.when_expected_result'),
        },
          {
            title: t('results'),
            content: t('fractional_co2_resurfacing.results'),
        },
    ]

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f08deb846821.31248578.jpg`} width={1} height={1} sx={{ objectFit: 'cover' }} />
                    </Box>
                </HalfSizeBanner>
            </Box>

            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '80px', xs: '50px' }}>
                <TextBtnSection data={TextBtnSectionData} />
            </Box>

            <Box marginTop={{ md: '107px', xs: '50px' }}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>
            <Box>
                <Box marginTop={{ md: '104px', xs: '50px' }} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>

            <Box sx={{ width: { xl: '1340px', xs: '90%' }, marginX: 'auto' }} marginTop={{ md: '90px', xs: '50px' }}>
                <Box sx={{ height: { md: 550, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            imageSize: { md: 6, xs: 12 },
                            book:`https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e FRACTIONAL CO₂ RESURFACING")}`,
                            type: t('fractional_co2_resurfacing.tech'),
                            // learn: '/',
                            title: t('fractional_co2_resurfacing.almaLaserTitle'),
                            size: { md: 6, xs: 12 },
                            btnContainer: { md: 12, xs: 12 },
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/27/Mask Group 8.png`,
                            flexDirection: { md: 'row-reverse', xs: 'column-reverse' },
                            description: t('fractional_co2_resurfacing.almaLaserDesc')
                        }}
                        extraStyle={{
                            backgroundColor: '#1E353D'
                        }}
                    />
                </Box>
            </Box>

            <Grid container gap={'56px'} className='generalContainer' sx={{ marginX: 'auto' }} marginTop={{ md: '82px', xs: '50px' }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'}>{t('treatment_areas')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Cards data={data} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} imageHeight={340} />
                </Grid>
            </Grid>

            <Grid container gap={{ md: '80px', xs: '30px' }} className='generalContainer' sx={{ marginX: 'auto', }} marginTop={{ md: '70px', xs: '50px' }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'600'}>{t('additional_information')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

            <Box bgcolor={'#f0f0ef'} mt={{md: '167px', xs: '50px'}} pb={{md: '172px', xs: '50px'}}>
                {/* <Box className="generalContainer" marginX={'auto'} paddingTop={{md:'120px', xs: '50px'}}>
                    <ContentCard
                        data={{
                            imageUrl: '${process.env.REACT_APP_SITE_URL}/images/2025/12/laser-alma-hybrid-2024-skinmed-clinic.png',
                            // type: 'Pairing',
                            learn: '/skin/hybrid-laser-erbium-glass',
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Hello I'm Interested In Erbium Glass SoftLift")}`,
                            title: t('fractional_co2_resurfacing.card1Title'),
                            description: t('fractional_co2_resurfacing.card1Desc'),
                            direction: { md: 'row-reverse', xs: 'row' }
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                </Box> */}
                <Box className="generalContainer" marginX={'auto'} mt={{md:'90px', xs: '50px'}} paddingTop={{md:'120px', xs: '50px'}}>
                    <ContentCard
                        data={{
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Alma_Co2.png`,
                            // learn: '/skin/hybrid-laser-erbium-glass',
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e Erbium Glass SoftLift")}`,
                            // type: 'Pairing',
                            title: t('fractional_co2_resurfacing.card2Title'),
                            description: t('fractional_co2_resurfacing.card2Desc'),
                            // direction: { md: 'row-reverse', xs: 'row' }
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                </Box>
                {/* <Box className="generalContainer" marginX={'auto'} mt={{md:'90px', xs: '50px'}}>
                    <ContentCard
                        data={{
                            imageUrl: '${process.env.REACT_APP_SITE_URL}/images/2025/12/Alma_Co2_2.png',
                            learn: '/skin/hybrid-laser-erbium-glass',
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Hello I'm Interested In CO2 + SoftLift + TED")}`,
                            // type: 'Pairing',
                            title: 'CO2 + SoftLift + TED',
                            description: 'Alma Hybrid complements Fractional CO₂ in staged rejuvenation plans. The initial Fractional CO₂ session provides deep ablation and collagen remodeling, while the subsequent Hybrid + Infusion treatment refines texture, evens tone, and accelerates healing through controlled non-ablative energy and targeted serum delivery. Together they achieve smoother, brighter, and more uniform skin with balanced recovery.',
                            direction: { md: 'row-reverse', xs: 'row' }
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                </Box> */}
            </Box>

            {/* <Box bgcolor={'#E9DFD5'}>
                <Grid container gap={{ md: '90px', xs: '50px' }} sx={{ width: { lg: '40%', md: '60%', xs: '90%' }, marginX: 'auto' }} paddingTop={{ md: '118px', xs: '50px' }} paddingBottom={{ md: '205px', xs: '50px' }}>
                    <Grid size={12}>
                        <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} marginBottom={'15px'} fontWeight={'bold'}>{t('homepage.resultGallery')}</Typography>
                        <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.5rem'} fontWeight={'bold'}>{t('homepage.resultGalleryDesc')}</Typography>
                    </Grid>
                    <Grid size={12}>
                        <CompareSlider imageSet={imageSet} height={{ md: '480px', xs: '300px' }} dayShow={true} />
                    </Grid>
                </Grid>
            </Box> */}

            {/* <Box className="generalContainer" marginX={'auto'} paddingTop={{ md: '129px', xs: '50px' }} marginBottom={{ md: '135px', xs: '50px' }}>
                <ContentCard
                    data={{
                        imageUrl: '${process.env.REACT_APP_SITE_URL}/images/2025/12/Emfusion-Trans-Dermal-Facial.png',
                        type: 'Pairing',
                        // learn: '/skin/emfusion-trans-dermal-infusion-facial',
                        book: `https://wa.me/+383049909090?text=${encodeURIComponent("Hello I'm Interested In Emfusion Facial")}`,
                        title: 'Emfusion Facial',
                        description: 'Fractional CO₂ pairs well with a post-laser infusion therapy like our Emfusion Facial to accelerate healing and boost hydration, or with pre-treatment enzyme facials to condition the skin for optimal results.',
                        direction: { md: 'row-reverse', xs: 'row' }
                    }}
                    heigth={{ md: '440px', xs: 'auto' }}
                />
            </Box> */}

        </Box>
    )
}